<template>
  <div id="articles" ref="main">
    <div class="content animated" ref="content">
      <div class="card-title section-title">
        <i class="anyteachicon anyteach-chuangxindian" />理念
      </div>
      <div class="card">
        <div class="item" v-for="item in articles" :key="item.id" @click="getData(item.id)">
          <div class="item-title">{{ item.title }}</div>
          <div class="item-icon">
            <i class="anyteachicon anyteach-xiazai9" />
          </div>
        </div>
      </div>
    </div>
    <Modal
      v-if="showContent"
      :title="articleTitle"
      :showComplete="false"
      :showClose="true"
      v-on:complete="closeModal"
      v-on:dismiss="closeModal"
      :tapToDismiss="true"
      :html="articleContent"
    ></Modal>
  </div>
</template>

<script>

import Modal from "@/components/popup/Modal"
export default {
  name: "Articles",
  props: {
    articles: {
      type: Array,
      default: function () {
        return []
      }
    },
  },
  components: {
    Modal,
  },
  data() {
    return {
      showContent: false,
      articleContent: "",
      articleTitle: "",
      loadedArticles: {},
    }
  },
  watch: {
    showContent: function (val) {
      if (val) {
        this.$toastHide()
      }
    }
  },
  methods: {
    closeModal() {
      this.showContent = false
    },
    async getData(articleId) {
      this.$toastLoading("正在载入...")
      try {
        if (typeof (this.loadedArticles[articleId]) !== "undefined") {
          this.articleContent = this.loadedArticles[articleId].content
          this.articleTitle = this.loadedArticles[articleId].title
          this.showContent = true
          return
        }
        const { content, title } = await this.$api.article.DETAIL(articleId)
        this.articleContent = content
        this.articleTitle = title
        this.showContent = true
        this.loadedArticles[articleId] = { content, title }
      } catch (err) {
        this.showContent = false
        throw new Error(err)
      }
    }
  },
}
</script>
<style lang="scss" scoped>
@import "../style.scss";
#articles {
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  padding: 15px 0;
  .card-title {
    margin: 0 5% 15px 5%;
  }
  .card {
    .item {
      font-weight: bold;
      font-size: 0.9rem;
      position: relative;
      transition: all 0.1s;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:active {
        opacity: 0.6;
      }
    }
  }
}

@mixin btn() {
  $buttonWidth: 160px;
  @include avenir-demi();
  line-height: 42px;
  border-radius: 42px;
  width: $buttonWidth;
  height: 42px;
  box-sizing: content-box;
  margin: 0 auto;
  font-size: 0.9rem;
  border: 1px solid $red;
  transition: all 0.1s;
  text-align: center;
  &:active {
    opacity: 0.6;
  }
  i,
  span {
    font-size: inherit;
  }
  i {
    font-weight: 400;
  }
}
.btn-primary {
  @include btn();
  color: white;
  background: $red;
}

.tab {
  display: inline-block;
  height: 30px;
  margin: 0 auto 15px auto;

  .wrapper {
    border-radius: 30px;
    background: #e6e6e6;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  span {
    width: 80px;
    height: 35px;
  }

  .block {
    border-radius: 50px;
    border: 1px solid #e6e6e6;
    position: absolute;
    background: white;
    top: 0;
    left: 0;
    transition: transform 0.3s;
    box-shadow: 0 0 20px -5px #cacaca;
  }

  .tab-item {
    z-index: 1;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.1s;
    &:active {
      transform: scale(0.9);
    }
  }

  .active {
    font-weight: bold;
    &:active {
      transform: none;
    }
  }
}

.card {
  width: 90%;
  margin: auto 5%;
  margin-bottom: 15px;
  background: #f7f7f7;
  border-radius: 4px;
  padding: 10px 15px;
  text-align: left;

  &:last-child {
    margin-bottom: 0;
  }
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
    .left {
      padding-right: 10px;
      i {
        font-size: 35px;
        color: $red;
      }
    }
    .right {
      h3 {
        @include avenir-demi();
        font-size: 1rem;
      }
      h4 {
        @include avenir();
        font-size: 0.9rem;
        font-weight: 400;
        opacity: 0.6;
        line-height: 1.2;
      }
    }
  }
}
</style>
